module.exports = __webpack_public_path__ + "static/media/a.c0c86d43.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/component/sounds/a.mp3
// module id = 90
// module chunks = 0